<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Delete Report] ' + report.report_name + ' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/reports">My Reports</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/reports/view/${report.id}`">{{ report.report_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Delete
                    </li>
                </ol>
            </nav>

            <h4 class="page-header">
                <span class="text-muted">{{ report.report_name }}:</span> Delete
            </h4>

            <div class="row mb-2">
                <div class="col-md-8 col-12">

                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this report and all it's schedules. This cannot be undone.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteReport()" :disabled="deleting">
                    <template v-if="deleting"><i class="fas fa-spin fa-spinner"></i> Deleting...</template>
                    <template v-else><i class="fas fa-trash"></i> Delete</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                report: {},
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            getReport(){
                //Send it
                this.$http.get('/reports/view/' + this.id)
                    .then(response => {
                        //Set the product
                        this.report = response.data.report;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteReport(){
                //Helpers
                this.deleting = true;
                this.errors = {};

                //Send it
                this.$http
                .post('/reports/delete/' + this.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Report Delete');

                    //Return to main list?
                    this.$router.push('/reports');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Report Schedules');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },

        },

        mounted() {
            //Get the Product
            this.getReport();
        }
    }
</script>
